import React from 'react';

const NotAuthorized = () => {

    return (
        <div>
            <p className="text-center wk-size-5 mt-20">
                You are not authorized to access any pages, please connect with your admin and ask to assign some roles to access pages.
            </p>
        </div>
    );
};

export default NotAuthorized;
